// src/components/common/SiteFooter.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="cp-footer">
      <div className="cp-footer__inner">
        <div className="cp-footer__col">
          <h4>{t('footer.product', 'Producto')}</h4>
          <ul>
            <li><Link to="/dashboard">{t('footer.overview','Resumen')}</Link></li>
            <li><Link to="/uploads">{t('footer.uploads','Subir cartolas')}</Link></li>
            <li><Link to="/installments">{t('footer.installments','Cuotas')}</Link></li>
            <li><Link to="/goals">{t('footer.goals','Metas')}</Link></li>
            <li><Link to="/forecast">{t('footer.forecast','Pronósticos')}</Link></li>
          </ul>
        </div>

        <div className="cp-footer__col">
          <h4>{t('footer.resources','Recursos')}</h4>
          <ul>
            <li><a href="/help">{t('footer.helpCenter','Centro de ayuda')}</a></li>
            <li><a href="/faq">{t('footer.faq','Preguntas frecuentes')}</a></li>
            <li><a href="/security">{t('footer.security','Seguridad')}</a></li>
          </ul>
        </div>

        <div className="cp-footer__col">
          <h4>{t('footer.company','Compañía')}</h4>
          <ul>
            <li><Link to="/pricing">{t('footer.pricing','Precios')}</Link></li>
            <li><a href="/changelog">{t('footer.changelog','Changelog')}</a></li>
            <li><a href="/about">{t('footer.about','Sobre nosotros')}</a></li>
          </ul>
        </div>

        <div className="cp-footer__col">
          <h4>{t('footer.legal','Legal')}</h4>
          <ul>
            <li><Link to="/terms">{t('footer.terms','Términos')}</Link></li>
            <li><Link to="/privacy">{t('footer.privacy','Privacidad')}</Link></li>
            <li><Link to="/data-deletion">{t('footer.dataDeletion','Eliminación de datos')}</Link></li>
            <li><Link to="/cookies">{t('footer.cookies','Cookies')}</Link></li>
          </ul>
        </div>

        <div className="cp-footer__col">
          <h4>{t('footer.support','Contacto & Soporte')}</h4>
          <ul>
            <li><a href="mailto:soporte@cartolapro.com">soporte@cartolapro.com</a></li>
            <li><a href="https://instagram.com/cartolaprocl" target="_blank" rel="noreferrer">Instagram</a></li>
            <li><a href="https://wa.me/569XXXXXXXX" target="_blank" rel="noreferrer">WhatsApp</a></li>
          </ul>
        </div>
      </div>

      <div className="cp-footer__bottom">
        <span>© {new Date().getFullYear()} CartolaPro</span>
        <span>{t('footer.rights','Todos los derechos reservados')}</span>
      </div>
    </footer>
  );
}